export default "__VITE_ASSET__1f0097d7__"